module.exports = __webpack_public_path__ + "static/img/201-1.706f34b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dnaerGirls/201-1.png
// module id = s12L
// module chunks = 1